export default {
 language: 'en'
}